'use client';

import React, { useEffect, useRef } from 'react';
import { BodyContainer, CloseDeliveryInfoDialogButton, DeliveryInfoDialogContainer, DeliveryInfoDialogHeader, DeliveryInfoTitleContainer, DeliveryXmlDownloadButton, FooterContainer, ProductKeyTableContainer, StyledTableRow } from "./index.styled.mjs";
import { DeliveryInfoTabs } from "./DeliveryInfoTabs.mjs";
import { useFocusTrap } from "../../hooks/useFocusTrap/index.mjs";
import download from "../../utils/downloadFile.mjs";
import { Backdrop } from "../../../core/components/Backdrop/index.mjs";
import { TableCell } from "../../../core/components/TableCell/index.mjs";
export function DeliveryInfoDialog(_ref) {
  var title = _ref.title,
    xml = _ref.xml,
    fileNames = _ref.fileNames,
    primaryReleaseIdLabel = _ref.primaryReleaseIdLabel,
    primaryReleaseId = _ref.primaryReleaseId,
    batchIdLabel = _ref.batchIdLabel,
    batchId = _ref.batchId,
    xmlTabLabel = _ref.xmlTabLabel,
    filesTabLabel = _ref.filesTabLabel,
    filesFoundLabel = _ref.filesFoundLabel,
    downloadLabel = _ref.downloadLabel,
    onDownload = _ref.onDownload,
    closeLabel = _ref.closeLabel,
    onClose = _ref.onClose;
  var downloadXmlButtonRef = useRef(null);
  var lastBtnRef = useRef(null);
  useEffect(function () {
    var _downloadXmlButtonRef;
    (_downloadXmlButtonRef = downloadXmlButtonRef.current) === null || _downloadXmlButtonRef === void 0 || _downloadXmlButtonRef.focus();
  }, []);
  useFocusTrap(downloadXmlButtonRef, lastBtnRef);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Backdrop, {
    center: true,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DeliveryInfoDialogContainer, {
    "data-testid": "delivery-info-dialog-container",
    dialogTitle: /*#__PURE__*/React.createElement(DeliveryInfoTitleContainer, {
      "data-testid": "delivery-info-dialog-title-container"
    }, title),
    "aria-label": "delivery-info-dialog",
    body: /*#__PURE__*/React.createElement(BodyContainer, null, /*#__PURE__*/React.createElement(DeliveryInfoDialogHeader, null, /*#__PURE__*/React.createElement(ProductKeyTableContainer, null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement(StyledTableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      className: "delivery-info-dialog-primary-release-id-label",
      "data-testid": "delivery-info-dialog-primary-release-id-label"
    }, primaryReleaseIdLabel), /*#__PURE__*/React.createElement(TableCell, {
      className: "delivery-info-dialog-primary-release-id-value",
      "data-testid": "delivery-info-dialog-primary-release-id-value"
    }, primaryReleaseId)), /*#__PURE__*/React.createElement(StyledTableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      className: "delivery-info-dialog-batch-id-label",
      "data-testid": "delivery-info-dialog-batch-id-label"
    }, batchIdLabel), /*#__PURE__*/React.createElement(TableCell, {
      className: "delivery-info-dialog-batch-id-label",
      "data-testid": "delivery-info-dialog-batch-id-value"
    }, batchId)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DeliveryXmlDownloadButton, {
      ref: downloadXmlButtonRef,
      "data-testid": "delivery-info-dialog-xml-download-button",
      buttonSize: "sm",
      onClick: function onClick() {
        download(new Blob([xml]), title);
        if (onDownload) {
          onDownload();
        }
      }
    }, downloadLabel))), /*#__PURE__*/React.createElement(DeliveryInfoTabs, {
      xml: xml,
      fileNames: fileNames,
      xmlTabLabel: xmlTabLabel,
      filesTabLabel: filesTabLabel,
      filesFoundLabel: filesFoundLabel
    })),
    footer: /*#__PURE__*/React.createElement(FooterContainer, null, /*#__PURE__*/React.createElement(CloseDeliveryInfoDialogButton, {
      "data-testid": "delivery-info-dialog-close-button",
      buttonSize: "md",
      semanticColor: "textBrightAccent",
      condensed: true,
      onClick: onClose,
      ref: lastBtnRef
    }, closeLabel))
  })));
}
export default DeliveryInfoDialog;